var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterDataIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.62 19.12C90.62 17.4631 89.2768 16.12 87.62 16.12H73.92C72.2631 16.12 70.92 17.4631 70.92 19.12V32.88C70.92 34.5369 72.2631 35.88 73.92 35.88H87.62C89.2768 35.88 90.62 34.5369 90.62 32.88V19.12Z",
    fill: "#29ABE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98 44.52C98 42.8631 96.6568 41.52 95 41.52H81.3C79.6431 41.52 78.3 42.8631 78.3 44.52V58.28C78.3 59.9369 79.6431 61.28 81.3 61.28H95C96.6568 61.28 98 59.9369 98 58.28V44.52Z",
    fill: "#29ABE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.62 69.94C90.62 68.2831 89.2768 66.94 87.62 66.94H73.92C72.2631 66.94 70.92 68.2831 70.92 69.94V83.7C70.92 85.3568 72.2631 86.7 73.92 86.7H87.62C89.2768 86.7 90.62 85.3568 90.62 83.7V69.94Z",
    fill: "#29ABE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.08 67.12C29.08 65.4631 27.7369 64.12 26.08 64.12H12.38C10.7231 64.12 9.38 65.4631 9.38 67.12V80.88C9.38 82.5368 10.7232 83.88 12.38 83.88H26.08C27.7369 83.88 29.08 82.5368 29.08 80.88V67.12Z",
    fill: "#29ABE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 41.7C21.7 40.0431 20.3569 38.7 18.7 38.7H5C3.34314 38.7 2 40.0431 2 41.7V55.46C2 57.1169 3.34315 58.46 5 58.46H18.7C20.3569 58.46 21.7 57.1169 21.7 55.46V41.7Z",
    fill: "#29ABE2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.08 16.3C29.08 14.6431 27.7369 13.3 26.08 13.3H12.38C10.7231 13.3 9.38 14.6431 9.38 16.3V30.06C9.38 31.7169 10.7232 33.06 12.38 33.06H26.08C27.7369 33.06 29.08 31.7169 29.08 30.06V16.3Z",
    fill: "#29ABE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21V39",
    stroke: "#F7931E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.08 38.7V25.06H70.92",
    stroke: "#F7931E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50H78.3",
    stroke: "#F7931E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.08 61.3V75.88H70.92",
    stroke: "#F7931E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52 61V79",
    stroke: "#F7931E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42 61V74H29",
    stroke: "#F7931E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.24 50H36.46",
    stroke: "#F7931E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.08 24.58H38.92V38.7",
    stroke: "#F7931E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.62 81.24C58.62 79.5831 57.2769 78.24 55.62 78.24H44.38C42.7232 78.24 41.38 79.5831 41.38 81.24V95C41.38 96.6569 42.7232 98 44.38 98H55.62C57.2769 98 58.62 96.6569 58.62 95V81.24Z",
    fill: "#29ABE2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.08 5C61.08 3.34314 59.7369 2 58.08 2H44.38C42.7231 2 41.38 3.34315 41.38 5V18.76C41.38 20.4169 42.7232 21.76 44.38 21.76H58.08C59.7369 21.76 61.08 20.4169 61.08 18.76V5Z",
    fill: "#29ABE2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66 41.7C66 40.0431 64.6569 38.7 63 38.7H39.46C37.8032 38.7 36.46 40.0431 36.46 41.7V58.28C36.46 59.9369 37.8032 61.28 39.46 61.28H63C64.6569 61.28 66 59.9369 66 58.28V41.7Z",
    fill: "#29ABE2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.46 48.58H50V51.4H52.46V48.58Z",
    fill: "#F7931E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3 48.58H59.84V51.4H62.3V48.58Z",
    fill: "#F7931E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.62 48.58H40.16V51.4H42.62V48.58Z",
    fill: "#F7931E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterDataIcon);
export default __webpack_public_path__ + "static/media/MasterDataIcon.83fd566ea96b97a936a08af98ac8b6ba.svg";
export { ForwardRef as ReactComponent };